"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logout = void 0;
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ZButton_1 = require("../../components/ZButton/ZButton");
const languages_1 = require("../../languages");
const LogoutContainer = styled_components_1.default.span `
   .k-button {
      margin-bottom: 10px;
   }
`;
exports.Logout = (props) => {
    const { languageId } = react_1.default.useContext(languages_1.llContext);
    const [redirect, setRedirect] = react_1.default.useState(false);
    const Redir = () => {
        if (props.client) {
            window.location.href = document.location.origin;
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/Login" });
    };
    return redirect ? (react_1.default.createElement(Redir, null)) : (react_1.default.createElement(LogoutContainer, null,
        react_1.default.createElement("h2", null, languages_1.ll({
            key: "LogoutHeader",
            languageId: languageId || "en-US"
        })),
        react_1.default.createElement(ZButton_1.ZButton, { primary: true, onClick: () => setRedirect(true) }, "LogoutMessage")));
};
//# sourceMappingURL=Logout.js.map